/**
 * Main
 */
(function ($) {
    "use strict";

    // Show/hide JavaScript related elements.

    $('.hide-if-js').hide();
    $('.hide-if-no-js').show();



})(jQuery);

(function ($) {
    $('.btn-social').click(function (e) {
        e.preventDefault();
        var url = $(this).attr('data-url');
        window.open(url, 'share-dialog', "width=626,height=436");
    });

})(jQuery);

(function ($) {
    "use strict";

    $(document).ready(function () {
        if ($('#launch-date').length > 0) {
            var date = $('#counter-wrapper').data('date');
            var countDownDate = new Date(date).getTime();

            // Update the count down every 1 second
            var x = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Display the result in the element with id="demo"
                document.getElementById("counter").innerHTML = days + " <span class='font-light'>dagen,</span> " + hours + " <span class='font-light'>uur,</span> " + minutes + " <span class='font-light'>minuten,</span> " + seconds + " <span class='font-light'>seconden</span> ";

                // If the count down is finished, write some text 
                if (distance < 0) {
                    clearInterval(x);
                    document.getElementById("counter").innerHTML = "Het boek is gelanceerd!";
                }
            }, 1000);
        }
    });
})(jQuery);

(function ($) {
    "use strict";

    $(document).ready(function () {
        if ($('body').hasClass('home')) {
            $('.nav-link').on('click', function () {
                if(!$('.navbar-toggler').hasClass('collapsed')){
                    $('.navbar-toggler').addClass('collapsed');
                    $('#main-navigation-collapse').removeClass('show');
                }
            });
        }
    });

})(jQuery);  